<div class="container">
  <div class="searches-wrapper">
    
    <div class="search-list search-list-personal">
      Ricerche salvate:
      <select *ngIf="savedSearchStore.userSavedSearch" [(ngModel)]="selectedUserSearch">
        <option [ngValue]="null" selected></option>
        <option *ngFor="let savedSearch of savedSearchStore.userSavedSearch"
                [ngValue]="savedSearch">{{savedSearch.searchName}}</option>
      </select>
      <button type="button" class="button button-stackoverflow button-xs ml-1"
              [disabled]="this.selectedUserSearch?.searchName?.length < 1"
              (click)="searchFromSavedSearch(this.selectedUserSearch)">Cerca
      </button>
    </div>

    <div class="search-list search-list-default">
      Ricerche predefinite:
      <select *ngIf="savedSearchStore.predefinedSearch" [(ngModel)]="selectedPredefinedSearch">
        <option [ngValue]="null" selected></option>
        <option *ngFor="let predefinedSearch of savedSearchStore.predefinedSearch"
                [ngValue]="predefinedSearch">{{predefinedSearch.searchName}}</option>
      </select>
      <button type="button" class="button button-stackoverflow button-xs ml-1"
              [disabled]="this.selectedPredefinedSearch?.searchName?.length < 1"
              (click)="searchFromSavedSearch(this.selectedPredefinedSearch)">Cerca
      </button>
    </div>

    <div class="search-list d-md-none">
      <form [formGroup]="reactiveForm" (ngSubmit)="goToDetaglioIsin()" class="insert-isin-form">
        <mat-form-field class="full-width-field">
          <mat-label>Inserisci codice isin</mat-label>
          <input
            type="text"
            matInput
            formControlName="isin"
            [matAutocomplete]="auto"
            required>
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
              {{option}} | {{searchStore.autocompleteValues[option]}}
            </mat-option>
          </mat-autocomplete>
          <button
            [disabled]="reactiveForm.invalid"
            matSuffix
            mat-icon-button
            color="primary">
            <mat-icon class="fa fa-search"></mat-icon>
          </button>
        </mat-form-field>
      </form>
    </div>

  </div>
  <a class="close-icon" (click)="hidePanel()"><i class="fa fa-window-close fa-lg"></i></a>
  
</div>
